/**
 * Created by juyang 2017/9/23
 * service基类
 *
 * 提供2种服务数据获取的方式：
 * 1、callback回调 2、priomise
 *
 * 1、 var opt={
 *        callback:fn
 *  }
 *  var service=new serviceImp(opt)
 *  service.execute()
 *
 *
 * 2、new serviceImp(opt).execute().then(fn).then(......)
 *
 *
 */
/**
 * service基类
 */
'use strict';
define([
    './Class',
    '../utils/CommonUtil'
], function (Class, CommonUtil) {
    /**
     *  * 提供2种服务数据获取的方式：
     * 方式1、callback回调 2、priomise。
     * 方式 2，可以把回调的回调写成链式函数，this指向问题可以用$.proxy改写。
     * @ignore
     * @constructor
     * @classdesc 服务类基类
     * @alias G.base.ServiceBase
     * @augments G.base.Class
     * @param {Object} options - 必填，构造参数对象
     * @returns {Class} 实例化对象
     *@example
     * 1、 var opt={
     *        callback:fn
     *  }
     *  var service=new serviceImp(opt)
     *  service.Query()
     *
     *@example
     * 2、$.when(new serviceImp(opt).Query).then(fn).then(......)
     */
    var service = Class.extend({
        //默认配置项
        //传参和$.ajax一致
        options: {
            url: '',//服务路径
            params: undefined,
            dataType: 'jsonp'

        },

        initialize: function (options) {
            Class.setOptions(this, options);
        },


        /**
         * 真实查询的调用
         * @param option
         * @returns {*}
         * @method
         * @private
         */
        execute: function (option) {
            var dtd = $.Deferred();

            //option覆盖this.options，在深度拷贝拿到参数
            var _opt = $.extend(true, {}, this.options, option)
            _opt.success = this._getResult(dtd, _opt);
            _opt.error = this._getError(dtd, _opt);
            $.ajax(_opt)

            return dtd;
        },


        /**
         * 闭包返回匿名的回调函数。
         * @param dtd
         * @returns {Function}
         * @private
         */
        _getResult: function (dtd, opt) {
            var self = this;
            return function (d) {
                var context = !!opt.context ? opt.context : self;
                if (CommonUtil.isFunction(opt.callback)) {
                    var data = opt.stripData ? opt.stripData(d) : self.stripData(d)
                    opt.callback.call(context, data);
                }
                else {
                    var data = opt.stripData ? opt.stripData(d) : self.stripData(d)
                    if (data == null) {
                        dtd.reject(data);
                    }
                    dtd.resolveWith(context, [data]);
                }

            }
        },


        _getError: function (dtd, opt) {
            return function (data, status, xhr) {

                var context = !!opt.context ? opt.context : this;
                dtd.rejectWith(context, [data]);
                if (opt.error)
                    opt.error();
            }
        },

        /**
         * 可继承重写，在服务层次剖解数据到想要的结果，
         * 减少使用服务中不必要的代码。
         * @method
         * @private
         * @memberOf G.base.ServiceBase.prototype
         * @param d
         * @returns {Array}
         */
        stripData: function (d) {

            return d ? d : [];
        },

        /**
         * 销毁，对应initialize
         * @method
         * @memberOf G.base.ServiceBase.prototype
         */
        destroy: function () {
            for (var key in this) {
                this[key] = null;
                delete this[key];
            }
        }
    });
    return service;
})
